
import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

import { getToken,setToken,removeToken } from "@/utils/auth";

const store =  new Vuex.Store({
  state: {
    token: getToken() || '',
    userInfo: JSON.parse(localStorage.getItem('userInfo')) || null,
    isManager: localStorage.getItem('manager'),
    tag: localStorage.getItem('tag')
  },
  mutations: {
    SET_TOKEN(state, token) {
      state.token = token
      setToken(token)
    },
    SET_USER(state, user) {
      state.userInfo = user
      localStorage.setItem('userInfo', JSON.stringify(user))
    },
    SET_MANAGER(state, isManager){
      state.isManager = isManager
      localStorage.setItem('manager', isManager)
    },
    SET_TAG(state, tag){
      state.tag = tag
      localStorage.setItem('tag', tag)
    },
    LOGOUT(state) {
      state.token = ''
      state.userInfo = null
      removeToken()
      localStorage.removeItem('userInfo')
      localStorage.removeItem('manager')
      localStorage.removeItem('townNameCode')
      localStorage.removeItem('baseInfo')
      localStorage.removeItem('tag')
      localStorage.removeItem('ticket')
      localStorage.removeItem('token')
      localStorage.removeItem('selectOrg')
      localStorage.removeItem('accountingDate')
    }
  }
})

export default store